import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArchitectureDoor = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "architecture-door" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M5.5.75h13a1,1,0,0,1,1,1v21.5a0,0,0,0,1,0,0H4.5a0,0,0,0,1,0,0V1.75A1,1,0,0,1,5.5.75Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.75,11.625a.375.375,0,0,1,.375.375"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.375,12a.375.375,0,0,1,.375-.375"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.75,12.375A.375.375,0,0,1,15.375,12"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M16.125,12a.375.375,0,0,1-.375.375"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 1.5,
			y1: 23.25,
			x2: 22.5,
			y2: 23.25
		})
	]
});
export default SvgArchitectureDoor;
